export * from './StarSequence';
export { default } from './StarSequence';
